<template>
  <div class="pay-wrapper">
    <headerDiv />
    <div class="pay-box">
        <div v-if="isShow">
            <!-- // 图片 绿色勾 -->
             <img src="@/assets/images/payment _success.png" alt="">
            <p> {{ str }}</p>
        </div>
       <div v-else>
            <img src="@/assets/images/payment_failure.png" alt="">
           <p> {{ str }}</p>
       </div>
      <div class="bottom" @click="goHome">
        <span>返回首页</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import headerDiv from "../../layout/header/index.vue";
export default {
  components: {
    headerDiv,
  },
  data() {
    return {
      str: "",
      isShow: true,
      form: {
        guid: "",
        PayerID: "",
        paymentId: "",
      },
    };
  },
  // code=paypal&status=error&sum=3.39&order_no=20201224143245387616
  methods: {
    Confirm_PayPal() {
      let { guid, PayerID, paymentId } = this.$route.query;
      let that= this;
      axios
        .get(
          "https://api.fived.com.hk/payed/PaypalIpn",{ params: { guid, PayerID, paymentId },}
        ).then(function (response) {
          let bol = response.data;
          if (bol == "True") {
            that.str = "支付成功";
            that.isShow = true
          } else {
            that.str = "支付失败";
            that.isShow = false
          }
        }).catch(function (error) {
          console.log(error);
        });
    },
    goHome() {
      this.$router.push("/manageHome");
    }
  },
  mounted() {
    this.Confirm_PayPal();
  },
};
</script>

<style lang="scss" scoped>
.pay-wrapper {
  height: 100vh;
  width: 100%;
  background: #f6f6f6;
}
.pay-box {
  width: 80%;
  height: 42%;
  margin: 0 auto;
  margin-top: 10px;
  background: #fff;
  padding-top: 50px;
  overflow: hidden;
  border: 1px solid #dedede;
  line-height: 30px;
  text-align: center;
}
.pay-box div{
    width: 30%;
    margin: auto;
    line-height: 55px;
}
p{
  font-size: 21px;
}
.bottom{
    width: 70%;
    height: 55px;
    margin: auto;
    background: #FDB435;
    text-align: center;
    font-size: 30px;
    line-height: 70px;
    color: #FFFFFF;
    border-radius: 50px;
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/pages/view/homeManage/payReturn.vue